import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import logo from "./CentralPark_Logo_Long.png";
import { Route, Switch } from "react-router-dom";
import { Home } from "./modules/Home";
import { NoMatch } from "./modules/NoMatch";

function App() {
  return (
    <Stack width={"100%"} alignItems="center">
      <Stack spacing={2} alignItems="center" padding={2} sx={{ maxWidth: 500 }}>
        <img src={logo} alt="Logo" width={"100%"} />
        <Typography variant="h4">Day Pass</Typography>
        <Box sx={{ width: '100%' }}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="*">
              <NoMatch />
            </Route>
          </Switch>
        </Box>
      </Stack>
    </Stack>
  );
}

export default App;
